import React, { Suspense } from 'react'
import { Flex, Loading, Spinner } from 'ui/bend'

import StyledAdminWrapper from './StyledAdminWrapper'
import ContentStructure from 'components_v2/Admin/ContentStructure/ContentStructure'

const SeriesStructure = ({
  bonusItems = [],
  classes = [],
  seriesItems = []
}) => {
  const error = ''
  return (
    <StyledAdminWrapper>
      <Loading
        loading={false}
        error={Boolean(error)}
        LoadingComponent={
          <Flex
            height='100vh'
            width={['100%', '75%']}
            alignItems='center'
            justifyContent='center'
          >
            <Spinner />
          </Flex>
        }
        ErrorComponent={<Flex>{error}</Flex>}
      >
        <Suspense fallback=''>
          <ContentStructure
            bonusItems={bonusItems}
            classes={classes}
            seriesItems={seriesItems}
          />
        </Suspense>
      </Loading>
    </StyledAdminWrapper>
  )
}

export default SeriesStructure
